import { FormGroup } from '@angular/forms';
declare var $: any;
// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}
export function MustNotMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustNotMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value == matchingControl.value) {
            matchingControl.setErrors({ mustNotMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

export function IsMinor(matchingControlName: string) {

    return (formGroup: FormGroup) => {

        const matchingControl = formGroup.controls[matchingControlName];
        var dob = matchingControl.value;
        var txtDOB = dob.split("/");
        var dateString = txtDOB[2] + '/' + txtDOB[1] + '/' + txtDOB[0];
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        if (matchingControl.errors && !matchingControl.errors.minor) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        if (age < 18) {
            matchingControl.setErrors({ minor: true });
        }
        else {
            matchingControl.setErrors(null);
        }

    }
}

export const IsValidARN = "^[0-9]{1,6}$";
export const IsValidMobile = "^((\\+91-?)|0)?[6-9]{1}[0-9]{9}$";
export const IsValidPAN = "^[A-Z]{3}[ABCFGJLTPH]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$";
export const IsValidPANIndividual = "^[A-Z]{3}[P]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$";
export const IsValidOTP = "^[0-9]{6}$";
export const IsValidEUIN = "^E[0-9]{6}$";
export const IsValidEUINWithCapitalE = "^[E][0-9]{6}$";
export const IsValidPinCode = "^[1-9][0-9]{5}$";
export const IsValidPassword = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&#])[A-Za-z0-9@$!%*?&#]{8,14}$";
export const IsMICRCode = "^[0-9]{9}$";
export const IFSCCode = "^[A-Z]{4}0[A-Z0-9]{6}$";
export const NumberOnly = "^[0-9]*$";
export const NumberOnlyWithDecimal = "^[0-9]*.[0-9]*$";
export const AmountWithOptionalTwoDecimal = "^[0-9]+(\\.[0-9]{1,2})?$";
export const CharacterOnly = "^[A-Za-z]*$";
export const AlphaNumericOnly = "^[A-Za-z0-9]*$";
export const CharacterANDSpaceOnly = "^[a-zA-Z]{1,}( [a-zA-Z ]{1,})$";
export const CharacterAndOptionalSpace = "^[A-Za-z][A-Za-z ?]*$";
export const IsValidName = "^[a-zA-Z]{1,}( [a-zA-Z. ]{1,})$";
export const IsValidCompanyName = "^[a-zA-Z0-9]{1,}[a-zA-Z0-9@&.()]{1,}([ A-Za-z0-9@.&()]{1,})$";
export const IsValidDate = "^([0-2][0-9]|(3)[0-1])\/(((0)[1-9])|((1)[0-2]))\/([1-9][0-9]{3})$";
export const IsValidDateDash = "^([0-2][0-9]|(3)[0-1])-(((0)[1-9])|((1)[0-2]))-([1-9][0-9]{3})$";
//export const IsValidEmail = "^\w+([\.-]?\w+)*@\w+([\.]?\w+)*(\.\w{2,3})+$";
export const IsValidEmail = "";
export const IsValidAddress = "^[A-Za-z0-9\/ ,.-]+$";
export const IsValidAddressFD = "^[A-Za-z0-9\/ ]+$"; // Added by Yaksh
export const IsValidAadharNo = "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$"
export const IsValidUPIID = "^[\w.-]{4,20}@[\w.-]+$";//"^\w.+@\w+$"
export const IsDPID = "^[0-9]{6}$";
export const IsDPIDClientId = "^[0-9]{8}$";
export const IsDPIDNSDL = "^IN[0-9]{6}$";
export const IsDPIDCDSL = "^[0-9]{16}$";
export const isEmailValidate = "^[a-zA-Z0-9_\\-\\.]+[@][a-zA-Z0-9_\\-\\.]+[\\.][a-zA-Z]{2,3}$";
export const IsValidEmailID = "^[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*$";
export const CharacterOptionalSpaceAndSpecialChar = "^[A-Za-z][A-Za-z ?!@#$%^&*)(]*$";
// export const IsValidDate1 = "^(3[01]|[12][0-9]|0[1-9])/(1[0-2]|0[1-9])/[0-9]{4}$";  //Added by Saddam
export const IsValidDate1 = /(^(((0[1-9]|1[0-9]|2[0-8])[\/](0[1-9]|1[012]))|((29|30|31)[\/](0[13578]|1[02]))|((29|30)[\/](0[4,6,9]|11)))[\/](19|[2-9][0-9])\d\d$)|(^29[\/]02[\/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;   //Added by Saddam - This validates dd/mm/yyyy date format with leap year support.
export const IsValidAmount = "^[1-9][0-9]*$";   //First value cannot be zero - Added by Saddam
export const IsValidClientCode = "^[^0].*";   //Client code should not start with 0 - Added by Yaksh
export const IsValidDriverLicence = "^[A-Za-z0-9]{15}$";   //Driver licence - Added by Yaksh
export const IsValidPassport = "^[A-PR-WY][0-9]{7}$";   //Indian Passport - one letter (excluding Q, X, Z) followed by 7 digits

$(document).ready(function () {
    $(".numonly").on("input", function () {
        var regexp = /[^\d\.\-]/g;
        if ($(this).val().match(regexp)) {
            $(this).val($(this).val().replace(regexp, ''));
        }
    });

    $(".numonlywithslash").on("input", function () {
        var regexp = /[^(?!\/)[\d\/]*$(?<!\/)]/g;
        if ($(this).val().match(regexp)) {
            $(this).val($(this).val().replace(regexp, ""));
        }
    });

    $(".alphaonly").on("input", function () {
        var regexp = /[^a-zA-Z ]/g;
        if ($(this).val().match(regexp)) {
            $(this).val($(this).val().replace(regexp, ''));
        }
    });

    $(".alphaonlywithcomma").on("input", function () {
        var regexp = /[^a-zA-Z, ]/g;
        if ($(this).val().match(regexp)) {
            $(this).val($(this).val().replace(regexp, ''));
        }
    });

    //Added By Devang Mehta On 05-02-2025
    $(".numonly_WithoutLeadingZero").on("input", function () {
        var value = $(this).val();
        
        // Remove any non-digit, non-period, or non-negative symbol characters
        var regexp = /[^\d\.\-]/g;
        if (value.match(regexp)) {
            value = value.replace(regexp, '');
        }
    
        // Prevent leading zero unless it's followed by a decimal point
        if (/^0(?![\.])/g.test(value)) {
            value = value.replace(/^0/g, '');
        }
    
        // Allow the user to input '0.' at the start if needed (i.e., for decimal numbers like 0.5)
        if (value === "0") {
            value = "0.";
        }
    
        $(this).val(value);
    });
    //End By Devang Mehta

    $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');
    });
});
export function isNullOrUndefined(object: unknown) {
    let val: boolean = false;
    if (object == null || object == undefined || object == "" || object == "undefined" || object == "null") {
        val = true;
    }
    return val;
}

//Added By Ravi Vaghela
export function IsValidArray(data: []) {
    //In this method if array not null and not undefined and length >0 then it return true otherwise it return false
    let IsValid = false;
    if (data != null && data != undefined && data.length > 0) {
        IsValid = true;
    } else {
        IsValid = false;
    }

    return IsValid;
}

export const UPIHandler= ["@UPI",
    "@axisbank",
    "@sbi",
    "@citi",
"@citigold",
    "@hdfc",
    "@hsbc",
    "@icici",
    "@ybl",
    "@okhdfcbank",
    "@okaxis",
    "@BARODAMPAY",
    "@barodampay",
    "@allbank",
    "@indus",
    "@federal",
    "@sib",
    "@oksbi",
    "@okicici",
    "@kotak",
    "@obc",
    "@rbl",
    "@okaxis",
    "@apl",
    "@okhdfc"
]

//InCred Logo.
export let DefaultCompanyLogoBs64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfYAAACsCAYAAACJiY6ZAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAL+BJREFUeF7tnX+wFdWV7/teuPdyLz9EYfwFvAFf5EImAhqdgE4cuUyN8GICvgFHM6JD8uqN5FVNoqlK4q+a9yroZKxKUP8Q5o8nz1/llJiKYizw1QCpJCqJGAFnRn7MEzKAaBQkcPl14eLr7767qePhnNPde63u3uec76fqlN0H5Jzus3t/11p77bVaPgkJCCGEENIQtNr/EkIIIaQBoLATQgghDYR6KP6T379nj2S0nHOxPSKEkPzQmMM4f5EiURf2w39/dfDJ8cP2zI2WIcOD4Xe/Zs8IISQ/epfODk4f3GvP0tM68uJg2J2v2DNC8kc9FC8VddA6cow9IoSQfJGIOuD8RYpGVdhPH1QKw4ceOyGE5I2GYxJ0cv4ixaIq7Grr6+dyfYoQkj+nP5Z566D1HHrspFhU19hPbV0fHH32b+2ZOx0zvxF0XLfYnpGigKHWv2+bCU3Ck4lClKc//rQB12oNMYQgEW0ZdOGkoPWCiUFL5wjzPiH1Qv9vNwZHHl9kz9zg/EWKRlXY+zY8HRxf/Q/2zJ3OG5cEbdPm2jOSB58cOxROam8Gp3b+Ouh/f1v42hoE0rCkFfm2yT3B4PFXBa0Xdts/IMRP+t56MTj+wn32zA3OX6RoVIX9+JqHgr7Xn7Jn7nT99ePB4AlX2TOSFRDzk5tXBSffWRf073rDvpsdLSMvDtom9QQdMxaaY0J848TPlgUn1j9mz9zg/EWKRjd5TmF9CrQw+SRT+ndtDI6s+Fpw+AfXmAhLHqIOPjn4nonqHF56vfl8fA9CfEIjeY7zFyka3eS5EwoZpSFMPsmGk5teNIJ6ZMWi3MS8Gvh8fA98Hwg+IT5glqCEcP4iRaMr7GVJVa7Q4tUFnnHvsvnBsZ/cV7igl4PvAw8ekYNPjukYhoQUBZJHOX+RolHex66wVYRrr2pgaSTy0E+/v82+6ycI0fcun0/vnRSK1DlhcRriA2rCrlLYIYQPhg4DQrnAOw+9FhB1eO/47oQUgdQ5YXEt4gNqwq6VOMeqTTKQ6X702W8ObDtUMrbyBt/9xPpl9oyQfNConMniWsQH9ELxfb32QAb2PRM3YFzBSz+1dZ19p3458bPHKO4kVzQqZzLiSHxATdj7DyhtdWMoywmTIBeKeiOtUUPcGZYneaGRvMn5i/iA3hq7Up14WrzpGdjGtqhuQ++1QFje98Q/0hjoJP9y/iLFo7fGruUpdgyzByQJEHVsY2tkjjz7t9wKRzJHJQGY8xfxAEVh1wnFDzqPFm9SEH5vdFEHWF5AWJ6QLNFwTjh/ER/QC8UreVQt5zCrNAlmj7pCJ716AWvtLEFLskTDOeH8RXxArQnM4b+/WhzKQuLJ8Ltfs2ekGkbU/0+2pVhbhowIBl3UHQyeNCtoGXlRMOjCbvNeaXJQ1MoVng5E9/T7W4NTO7PbNz9o/FXB0EWP2zNCdOldtsCMYVdQXGvYna/YM0KKQ03YD/3dZfbIHbT27OLEHQv2qWe1pQ1dqdqnLwxF9EqnDF+IPLzrU++sU/GAyhm6aIX5boRoI3VOOH8RX1AJxaslzpFY0FYyC1GHoGNSMi0nJ810EnUAr2XI7O+Yf6t9xkL7rh7HhS01CakEBF2cPMfiWsQTVIRdbasbi9PUBCF4aa/ocrA954yghx6HFmcE/pZHnY2ESqBErtZ4IyRCo3Imu7oRX1AJxZ/auj44qpDI1THzG0HHdYvtmT9ASPr3bTuzplwKRAviCCFrvbDbvpsNAz3M9dawEXLvmLlYVXgrgYjO0fC7a4XmO64Lx0n4vX3ljOHRPixo6RwxcJwxKCX8ye/3Bf3vY5yGx5XGagc6j40w1R3NuL1gYm7fTxNca/9v36x4jWeexZTX1v/bjcGRxxfZMzd8nb9I86Ei7FhTNbXJhXTeuCRomzbXnlUGxUqkIbO4NVpMHCc3rwpOvrNuoD9z0s8LJ0tMmu2Xzw0Gd89UnTS196sPmfPdUNhvtWfZc/qDbUHvY/PtmYy4JCXpGDGil8BIiwTm1M5fB6eQPAiRqfS51vhDAiLGuAb47NMfbA/H6NrgZGhYf+JoNCFKhu/VNnmWWYLxEVzrqW0/C+9xeJ93bkx8rS3hOEEUqv3yebHPfN9bLwbHX5A9X0nmL0LyQEXYj695KOh7/Sl75o4JB0+oHQ5GNni/IPO6VoILMruxhqvhFWNSaZ82z4g8jqWg65lWFnxRE1DfhmdCA/AH9kzG8Lteqbq1SJrIiUjGkDnfsWdng3FyYsNTAzsAUhgQgyf3BF03P2LP3HD97ESEBkjbpJ5gSOh5aoxZKbhWGC59oVErvVZcD66r2rhH7op0mSvJ/EVIHugkzymsT4GWBMkn0n7JlRJczPaxFQN9y7VC3VFRlV7zb8r2X8Nb1xJ1eOpFeRXt0//KeK4aVNtWp5HI2VqlQxd+x2icIOs/rdhIchgGyga7f3Yiwn8TnwMjEtGhLLdT1qL0PpteAQrXimvBNWFHSaXrkkYBQZL5i5A80EmeO6EzySRJPpGu05Z3j8PEkWXfckwimKAkncq0MsGxNp1n+L0SMCw0QM5DJTQS68qND4SCj69+yPyOknHSekH6HAyIXO+y+UaUshqjlYgEPs8Oe1r3uRbYUQJju7z/AJPnSCOhI+xSLzoE65pxFq+GN1aaKHbsJ/cP5AZk4f2UAe8dk2VatLx1hAh9SDiTbKUrxeQ+VEClAmJJvW9M+DD8+jbIl5rStCQuFbkim+Bg3GouA1XDGDBK9zkOXAuMpdLnUeqcJJm/CMkLpX3sCtZughCtpjcGUT+56QVznBcwItJOkGZ9UQgqxnXe+IA9K562y+fZI3eqJVBpjMWo3jcEVasVbpqJP/rcPEQuCUYIMzQwEDWDAZO18VBOaedAqXOitcREiAbi5DmsTaFik5QkVZtOKWyrQ4IL/p2iJs00ZVGNt/jwbHvmju/bwzTRSIIa8b/eHhDXUGy0ojlJxjeAF3kspyhSWmCcoPKf5rZORCWKNGCQVDfsjueDwz+QzWFJf19C8kDssWusTYGWKglLpWh4Y0WKOsDaYdJkur5fPWOP3IEn0SyiDqTLNdhKhzFtGuwoimuS4ktG1LGl0UNRBzDiNT1rRM2KjkrgWrCrR0qS+YuQvJCH4vt67YGMRKF4hQmvL+fweyWSJsNhq48UFM1oJqTGH8ZhFg124rZBnRF1z8EziEiGNJcBnnreS2HV0PgeDMUTnxALe/8BJY89QUKVSk16D7wheO1xE2P/vq1iccFk0zbtK/asOZAKzin8NsqiDtAhrxqI4NSDqEfg/kj642O5xJf8AS00EkIJ0UIs7Fp1u5NYvBqheF9ACctaxP15EgY1YbEM1wpsWYJJv1pGPML+R39yrz2Tg0RJFEVCAx5T4tS+2ib3qHqVSHhLuqRUCrabafc78AF67MQn5GvsWt5NyRajaqhsZfKEatu1IjT6mrdNbTJv/bhCh64MqLXNTSvsj50GSN4afverwZB5S0wDHtQtj16dNz8SDLtzjfk7GrsSQNr6CjBiTGJgI5Jg/iIkLxSEXcdDirYY1eJ0jBjWE3H3TVqgA15is5W31Erk1KZa4hxC0lJRh9Ew/K7/G3TO+36iynb4O/i7Q+Z8Txw+TpMICjSu11eSzF+E5IU8FK/kRVer+x2RtSeGEOagiwYauEQvCCPez4Ja+2Y1PM9mDMNrJXJqU6lELYwQaUi6bdq8YOjileGzU339vhoo79v11UftmTtolJQEJAeWFoTRpNKzq730EEfc/EVInoj3sWMPu1SE4rp1ASSTHVm+wJ7pAfFG0w90f6rmwZzctMpMwppr/PC0MClXQqOFZN7d23xAo0NXFlRqDoJkOYnQDZ48K+i6+WF75o503z+emeF3v2bPqpNF9Trz7F632DxL1Z5dLBUiHwD19bPK0Ul6DwjJC7nHruBJJ7KsM/DGIH5m0o0pc4rMcqxNJtmLnBT0zK4GjBgpLnXJ6x2tRM44MF7hFSKc3XnLwNp16QtjBe8jaQ3iU77GDm9dIur4fITTNYDxV2vsx4HnPy4cj2vVFHXcU9xj8+yOR1St+veH04B8A83cgnJq5VAQUgQiYVdLnEtQalNrW10EHvQ0Hi0miK5wspZMgknRuK/NWLdaw8isRZSgBvFGghrC2WhzCqEtfUFs8D6S1iA+5b8FvGQJMBi0xiH+HangxSWCajUxAoiuRYKeBjy/MIZw7whpdETCrrbVLUFXJE1vDJ562okBYHLANiINaq3dawhUM3oRWSXPwUNMk6BWCw1vXbs2gTS6U0vYUelRy1tHaeRaffKTAGNL6xmO0IzkEaKBTNi1EucSeJda3hi8E8naszR0GVHr32ik/fp5otU+uBSIifG6HRLUKiGtT9A+Qz9vYpCw9nt/ja2ZfW/pVJfT7HcAcYeBpAW7uhHfEIbidQQInnAcceG+pAwRhuIgyK0X0UL3EY32waVk0TxH2q0PSZ7atHTKdn5UM7rxPgrSSEGioObvgGe4878usWdyksxfhOSJF2vseW0Vgbeu4XlphLnZNEIfzUhHFqKOMHwt7zYJWSyxoPe7hGrC7lKZrhKdc75rj/QY9IdXqt1LbnUjviHa7nb02W+qWOTY9hX3kGlsqzNJN2XbjlzA9hn0cpZgSn1eV1k4UI1MKgBoPdpMwMjsXXq9PZOBMC0S5LTBerOk7TA8zcGTe+yZHsazTrgfvRqVxpt0Sx+AMa61A6Ac6Va/iCTzFyF5IltjV1rTTJQ8JxR1k62sIOqGjmzX2DXIa+uXL2he79CvrbBHuqDBjAQ8AyffelH9JRX1avS/v80euSNdOquF1nyQZP4iJE9kwq6wpgmBi0s+0Qj5+1aJrVbyjkZiT/8++aRaT2glcmot11RCK0+kHoARIi0BbfaoZ/RbAK1aD0yeI75RePJcEhHT8Makmb/qZNw0otky67WuN8vGOacVCg/5SKXksdMfyA3LLJYdSjFOhTByxhA88RFnYZeGxiOSPFga3phmJTYVQ6NG0wiNLFtp2Lfe0BiPqss1ZeD7aT0zvlHJONcoKJVH9UTpb5L1khohLjgLu4ZFDpJkh2t4Y5qWtcYEXSuTViPLFsl3jdTmNg6N5ZrBk7LzELWeFx+pVKBFJ8qWrTesYmgxDE88RBSK1yBJKN63EqvSCmdxVr7GsgEmrUYWk3I0jD/0DCDpQWe1cnx7Ziuh8XwwFE98xFnYNRqVgCShLKmQaheQkO4GiDNmWs+NN3aSoFmj23c0ohNZheGBdq8Dn2i9cKI9aj4Yiic+Uvgae6LkuYyFNC3S3QBxkwH+XCOLv3/XG+qtMn1FIwObpAfPVr16rafD5xjfX/oixDecC9Qce+H+4KRCHegkRWN6l84WhVqRXdt18yP2TM6hv7vMHrnRdvncoHNe7ZKWx9c8FPS9/pQ9c2dQKFhDFz1uzxoTGJkoYCQBXcOkDUZqodEr3kcRQV5CpfumMT8Mv+sVVnUjxAFnYdeojgaSPLxSIdWctDVEpFbVuQg0Czny+CJ7JmPoohWZ1BhPCpZSMNFLwZLKkNnfPWvtFctCR5YvsGduoOOfpDlQHFJhx7UPu/MVe+Y/GsLedcujzHsgxAH3ULxWZ7cYUdcI+fuUOAeSrPmjlrXW+t3Rn9xbWIY86pAbI3DXG+JX0NJS+bfs67UH7mTtDbcKG63UGypbNhUcB0KaEXdhV8hCTvLwawip6hqggogkDS+iCpoGWGeHuOZNJOpa6/zVyouqJKZlXDAoywpqPqJhlJ7cpNPylZBmo9DkuURekoKQak7aGiKSNILQplh5C8llaMqRF5Gon1aoFw7Qba2aOGZdMEgD6U4Hje1jeaIRAcEcI20iQ0gz4iTsWlvdkhR3yFNIk6AhIkmbRpjWkopbsDBJ9i5bkHmmPKIsvcsXqIk6RKL9iurRC5XlmoyTtODBSr3Yeqo136pUwhldFJup0BIhGrh57BpedEiirm45CmkS8i68od3dCp5774pFgVav7HLQ0hairmk8INmwVihbKnhauQxxtFYo5JIG7d8MhtfJTaucX7W+D5bZNO4rjLaj//RNe5Y9iDThvuDa8NIyTgnJE6es+FPCvtIRSbLDpdm1mFyG3/2aPZMj3Q3gkt0s/cxqtE2bawyHFoVEJ0yCKIhjktwUSdKPW3p/sIe9K4ctgdL+39pbFw8vvV5kgMX9NlpbYgHGaueNtbeIugIx79vwjOmvUHH8hnNIG7b1KT0rhGSNWyheKSSYKHlOmKSnne0sDQu6fJ+selIjNI/J/eiz3zTGGia4NCCacmL9MvNvHDFRAF1Rx71Kcu310jVNWtkO9xe/kwYwMqRRlbhOeFhK0iIaq9rLSIgwHX54dng/ahildq0fn488FS4NEN9xEnaNNU2QZF1T+hBph1nFuwEc1vu119rLObV1nYnAHP7BNaFAf82sa2LCg4hEIUkcI/wKQTj2wn3hJDc7OPyj682EmNWaPfaWJ8kml47HSk1MskBjC+MxbF0U3m+IlCRyAGB0xRkqSP7UfP5w3ZG4uhiipZjkTjvWIdxJwb0zOz0o7sRjnELxAx7eOnvmztDFK2O3oqEYjGTiTlLlLQ1FFcvB2v6RZfPVjCrfQRZ8x8zayzQA96U3nOwlJFkS0kIajgcIBw9btMIpLHx89UOh0SavaNh54wNB27T43vVH/+lbwal31tozfWCURcYDng1E+EbELL0ZURfu2GiGio6kfnHz2IW12yOS7C8Xe2OKoXiNxLnWBG1qK4Fli46Z/8OeNTZJRR2oJFfmuG6qUd2u1HNNIk4Da8hPm/9HQ9TxTCURddAxI7tqfgDJoAih44Xj1gQRApRrlibF4fPgvRPiI27CLmyCApKE6FQy0DVDgSoi4m5otE//q6B9xkJ71pi0TZuXWNSBRkg0661upWA8ahUegrD0LptvBBtRNBMNKHlhyQTbG7HEYraNKTxPoPOWh+1RPFkvI5UT93zhnmkJ8gmFXg6EZIGTsGv0vk4icEULaTkq62rCYjlDZn8n14kyTyDqnTfWzoAvR2MsatY5SALC/tprz1gaQ4i/9HXyrReNF6sJoilpKzlmlfxZkZjfUrOVsdkWp3x/CdEgtbBreNEgycTmg5CWoiEiGhXO0Kkur4SvvIBgpBV1oLI8oljnIAkI/ddj5AWCniaaEgGvPa/rrfVborGSVtQiAomlhPhGamHX8KJBS4K1Zl+ENEJlaUAh7AujqOuWxhF3ZL+7CAaQ9hLAvczbYwfw2usp8oLIV9dXH7Vn6cH1akbPqlHrtzz5jjzht5xmSWYl9UV6YVfa5pHkIfdFSCM0REQLeH3IykWv+XrFiEV4DZKEMmkiZx5iUw3s1ijy85OC7zj0aysSbT2shjFGv/qI6jNQiVqJkFmEzbntjfiIQyhe7kWDJA+4T0IKfBMRM1ne/Ejo7ea4hqnE4MmzzHZHVH2TIE3kzFpoagERgmHjs7gj/C4V9YjWC7qDIXO+Z8+yoZYhr5H0W04R0R5C4kjvsSuFnvCQx+GbkPoqIghzYl9xvXh/Xbc8GhokD6vcD6mhmWRJKEt8FnfUXIDxpSHqEdgmh7GaFXkLbdpEQkLyoLDkuST4JqQ+iwgmTAiE1lYqbVqGjDCRBeOlT5pp35WhYWT6IKiRuPuy5m6Mr/D7uBRSSoIZq6Fxl4WhWzMRMoPPGyRs7ENIFhQWik9i6fokpPUgIhAINOVAkxlfBD4S9GF3rjGRBc3JXLpUA7KKoqQFv93Qv4aYfq+w7/Qp40u4RBIHjLuhi59XfSZw32p57NoijGdMM5pBiBaFJc/Fhcx8E1INEcHknQc+CDzqiEOkshD0Myi0D/bBYy8FRYggeHn+blkaX7XAOMVnYpxo/A5x/0b75XPtkQ657s8nJAXphV3BY08icN4JqYKI5FnhDJQKPNY1pd3F4sC/HwlEV+h9QqSyFIn+A/IxolnnQIvy3y0L4wNiboyveUtyF/RyME4GQv/fFV1r3PfHfnqte4n8A3rrxFecmsCQ+gWREGz7QXcsU2d737bwvfRdsjBBDrqoO2jBf8dfaUK3RQlDM4DfrH/Xm+Hr1+Y3S7tMBSHH74XaBwiDYynM198LfdExPk0N+AQteRFiR1OW9svnBa0XTLTvVgb/LjoZSjA7BRavtGeE+AeFnRixh1CY/9qExdJCRFGkAcsngy4MxTwUCYp4sZz1m53oPWOg4feJIhHG+Ap/qyy8/ryAUYPrNC+7FIhmSohsuFwXmsD0OdZ5h6gjusDxT3yGwk4IaTpc2uci/I4KiRR14jsUdkJIU3Jy0yoj7nHLGshFaL9uceY7BQjRgsJOCGlqsKaPZi7IOUG4Hx65Wb64cLLZc08PndQbFHZCCCGkgUi93Y0QQggh/kJhJ4QQQhoICjshhBDSQFDYCSGEkAaCwk4IIYQ0EBR2QgghpIGgsBNCCCENBPex1wk73vtdsPujg8Ge/QeC/YeO2HcHGDViaDB21HnBtAljgvOGD7Xv1jfHTvQFO/b9Lti+93fBR4ePmPNSxo0+N5g45vzg0ovODzo72u27pN7Zf6g3/N0/tGdudHW0BVPGj7VnhDQfFHbPgaD/9I23zX+TcOnF5we390yva4F/ObzedVu2B8f6Pi3mlehsbw+md08IbrjqcxT4BgDG3NIX1tozN0aFY//7t37FnhHSfDAU7zEvb3w7WPri2sSiDvB3H3hudejZH7Tv1Be43pc3/ksiUQf4e+vf3hY8sHJNcCD07AkhpNmhsHsKRP3lN/7FnqXjWN/J0Ov557oTuudf/U0qI6YUXOuPQqOgPGRPCCHNBoXdQ7DO6CrqERD3ehK6Ddt2Buu2bLNnbkDcEcInhJBmhsLuIdLkoQgI3U+FBkIeDBgyb9szGdvf+8AeEUJIc8LkOQ9BSFrqvZZyz01zgrGjRtoz/3hy3QbjsWvQ2d4W/PDr8+0ZqTeYPFf/aOxsGDvq3GDsaH/nLN+hsHvIk+t/FWzY+q49k4NM+TvnzrJnfoFJ4P5nXrJnOjy2+BZ7ROoNCnv983o4dz0VzmESvnTVZcGXrvycPSNpYSi+CUBCmmtSWtYgA54QQogeFPYmAXvhfQPeulYInhBCyAAU9ibBR6/9yZ/JwnWEEELOhsLeRPjktWMtdcdeP5cHCCGknqGwNxHw2H0Jfa/85W/sESGEEE0o7E2GD147jIs9H31szwghhGhCYW8yULSmaK9dqxgNIYSQs6GwNyHw2osqNQujYn+d1bAnhJB6gsLehBRZU53eOiGEZAuFvUlZt2Vr7l47vXVCCMkeCnuTgu5veXvt9NYJISR7KOxNTJ5eO711QgjJBwp7E5OX1w7jgd46IYTkA7u7eYh2d7daoM3pklu/EnR2tNt39Hl549uhsOfX7CWv7m4Heo+Y/fgfHToaHDjcGxzt6wv2H6oclRg1YmgwaviwYNzokcF54X99bqPrAu7F9r2/G7gfh4+cFQkaN/pcc90Tx5xf89rZ3a02uK+4R3FjDs/z6PA+4J5jzOGeZ/mMl9LI3d3S3n/8t4hnnsLuIXkKO/jSleFDdFU2DxEavTy8al2uYfishB3itendvcHmnbtDATsYHAsfalc629uDS0ORmzZhbDDx4vPDB3+o/RN9pB308P3Q+recqIlP2mUWXGvPlG5z7eXX7YOwm+vavsueyemZMtH83q6gYuTmnXvMS/Ic4TecOmFceN/HiMdbrTG1OzTutoTfVQK+68QxF9gzN3ouC++7gjGjdf8xBtBjHr9BnIErhcLuIXkLO4DXnoW45O2tA01hh4W+bsu2YPOuvZlWy5vePSG4IfRSsvgNvrHsWXvkRrn3BOHDGJU2FcK1zgivG/9+hA/C/uDK1cZw08DVaI7GHZbKJAZkNSCcGG+VDLYkSMdUHixZODc4b1iXPUtH1vcfYPzjN8jCsOcaOzFkUWoWApC3qGthxGvdhuDbj//YeCdZl8CF13vf06vMZ6LOgI9gsnv+1d8E9z/zkkqnQFznjvc+tGd+gOsrUtRxj5GPct/TL5lxl5Wo4Pdb+uLa4MHn1ng73ooCgp71/Qe473jes3juKezEAGHRfsClIeAiwMSKhwzihXuSN/jMB55bbSYXn4DYPbhyjfr3wnKELyC6pHV9UyaMTS3qEFvc46wFpZQ9+z82woKmTBj7zQyMeRg7MO7yuv8R2oY9hZ2c4YlwUGlh1ikLEEYJkaVe9PfGbgVMLr5MtsgpwISXRZ7EpRf5Iexbdu1Riy4hrHp7zxfsWTLwe2d1j5Ow/u1twQOhUdGs3vuAUfWKSiRKAuaeH4XjQDoHUdjJGTCotQZ2PXnrEM+iLPVaYLJdumpt4eIuTRSsBnZkIImoaGCEPrFWlsUdAVG/a96fJU6Ww2djTd+HCA1EHaKyZ7/OUkS9sGHbu+b59+XZx+8Az13ivVPYyafQWGuvJ289CjEXbalXA9/PB3HPgnGjz7NHxYGxil0bGpM6xByinjRhK/psrTV9DSAkS1/456YRd9z7J9fpGHXaYA7d5Li7gMJOPoWG114v3jqus8jwZ1Iw+ax89Tf2rHGYMmGMPSoOZPdr/f63z/pCalH3cexhKWj56p83fFgev8E/rvm5PfMPRH+wLdQFCjs5C4nXXi/eeiTqPoXea4F76ltCnRTXrVZaIFlOK1KDDPgp48fas3j+8ZVfeG1QQtQ1c258BA6Iz78BtsK5QmEnZyHx2uvFW0dxCOx3riewDapRQvJYX0c1uqKAkaSVLJd2WxsMCp/C79WQzAO+47sDMn3SJaa2hSsUdlIRF68dxUXqZW0dFan+Zs619qw+KKIjX1ZcKqwqJgGiikRJDdJua8PzUU+1HbKob+EDPjsgyNWQeOuAwk4q4mKt19skAK+9tOpZPVBEH/0sQDnZItBcV027rQ2fXW/NkBrVa/f5mrCu7loxL4LC3qBMDSdOSX1qkGaNDZ7Ijr2yh0USenIFpVJ9KpISR6N47WNybIgRAYNIK2Et7bY2kMWaLj4fSxomdBu+8NxrL3G8XidRuKSgiqTW74D7j3veM7XbOAnRC7+FS617jCuXEsTltLBWvH9o1IrHwMIastRDuK1neiLBvf/pVaKHxXg/s6aL64SDtLXi8b1RWtMlkc482JeMDb3/c8P73WWuo8s2nsC/CzFBnfkdez9Qm0zwWffcNNuexZNnXW/cj+j6j4bXXume4h6hN0ElsqwVv3z1L0whGim4xnv/ck4qrwreOqoZagExmRl6dqgzXgnc980795rnXzrukA/xw6/Pt2fx+N7dbUv4PCLrXwq+Y5IGP9vfG1iiTDIH3L1gtophNuh/hthj4gkaDUfGhoPjhvDB+MW//r/gVH+/fTc96NSERh1tgwfZd84Gg1a6tr7gTz5vBGHDVrl3gAcuDfjc9rZBwb/9xz77Tm3wIF/7uc8Ec6dPC776p1eZSXbCBaOCC88dEZzT1Wn+PbwgMHjPWPThJDxqxDDzu8LrlnDo2PFgxuT/bCbcJGS5nohWtJG3suBPrrCTXbd5XX/FZ82fffY/XWyuvaWlxUxsWF+/8jN/aP+FT4MOetIxgHtfvk0ICWu//Ld/t2cy/tufXx2MP3+UPUsG1vQ19obDC0RuiBlP4fiqRtugQWYOwLP7/sHDwQcHD9k/Sc+p/tOpxhvGOMRTAq6zmtEiZeO//4c4FD//miuC6y//rLnPceB3SjIHwBm79o8+Y89kMBTfwCBBDBOrBGx7iQv9SqMC8OCKCMOXMvOy7tiQPAQdwrVk4ZeD+VdfkXriwTV+a+4sM+FK2fTubntUDJh4cS3fv/XLxrPCvajkueA9/Bn+zre+0mM86QXhpJgn2hnwaba1Aa0MbAgD7mGadp+YA+6Y/UXxmNv9YbZNkPJEI3I27ZJx9igdmAPwDCASWmqYYQ6UJsyVQmFvcExP4phQURy1ErYwYUkfFM0BLeG2mdOrilMk6BAoyf3Ew/w34UQr/U2KqgyGCQiCDoFx8ahw/bU8TW0GEtaK2dYWoRExwWfDS3QF0RQJ+w/32iMCMK4klAs85kBpwlwpFPYGR8Nrr5Ww1QjeeoR5wP740xM3PFOsp0oFvRR8TtrlgnL2FOBBwWO896bZmYVItcHkq1Uu1qVbW4Q07IsQrTShStpsR7p81GhgjV4jsz6K4mnPgRT2JgBeu9RLquS1N5K3HlEako9Cn5qWdMSM7vEiQyHvinnwFvHSMm7yQKu6G4zPtN3aIpAMKPkO2iFaEgRdCXMFagFDB5Ur0YFRWno3iwgWhb0JgNcu9RAree1Sbx3rfr5466UgJA8rWhL6jAO/yagR7g+0hmClAUZOPWGS1RSqu0FY025rK2Xzu7IsfK0QrTQZt5E4b/gweyQHHRjRRx0iD0fHlxoTFPYmAQKq6bUjy1gqLkhA8xHcpyThZtwLrHXjgcY6KsTkyfUbguVrfmEe9PIX3sef4+/h7yfNMq6GL5OIb2BcatTVh5in6dZWid373QVVc5lKej+kY9Unxv2Bfg0FhOXRZvXbj//YPOdFizyFvYnAljIJkddusnyFW5ImXnxB4EMv7jTgQcUDC3HGvn08xA8+t9o80IheYPLEfdmyc4950MtfeB9/PpClLW9AcuzkKXtEsgAJZ1JvWVK0yaXASTkYszAkMW4loHZCo4B8gyyXlPCcRyIPgx73Pu9OeS0sUOMfWgVqbpt59rogentLJhtY7jPCf1vqAVQqxKBRnASkLVBTC0yMr2/bFWzeuVssxNosWTg3kfBoFKjRvKe10BoDUlwz4EtB+Bu9/l2BmHZ2uHvKEBOtJZukYw34XqAGwNjRiOqkAdEXzJ15dDWkx95kSBNxBrx22QMBo6PIzl5JgKDDq77v6ZfCSeBN70SdZAfyCTTKeh7oPWqP3Niz/+Mz0R6Xl5aoY0lAY53fJ1C1L2/gucODx5q8NIISB4W9yUAYquja6D5n+ZYKOtbB884+J8WC8LdW0uRHh/INv2aFxpKAbyCPpqiEUERSEKrPUuAp7E1IkcIKb91X6x9eDkKnFPTmRXMnRKOMoUbdbodQv0YVSFcigUefCu01eAp7E1Kk1+7rJIHlBYTJ8t5GRvziyXWv2yM5jTCWfDbEpWDLKapAZrGPPA1YcoH3rrnmT2FvUooQWF8nCWzdQzINIdj7jqIjZIBG9dYjIOr3LJhtKgsWjdkGK6wNEkFhb1KK8Np9nCQQfteqJU4aAxQd0WjvWu9gWaJRvfVSokY52N5YdGVFLANqeO4U9iYmT6H10VtHohzWuAgp54m1G3Lfe+wTSCyrt2qDUlBO+p6bZpu5qkjgtUvHHoW9iYHXntcg9tFbXxd6ZlxTJ5XAts7la35ujL9mY3r3JZmWU/YZhOZR/wMlpYvaDYCx94TQ4aCwNzlZFoGI8NVbl1bPqwRCeaOGDwumThhrrrv8hfcxYeBVdNiP1Abr7T8VLNMUnZSVFoxHCPptjg1vGgmUlEYDKBTSwnObN1EtAlco7E0OJp8sBy4mCx+99c279qp567hGVMrCJPDDr/9F8P1bv2yybWH5l7/wPiYMvCRNYEh1MKa18kew3u6617ie1qdhaKI9cbOF3+NAIS08t1Hv9DwLa/1UkEhHYSeqvcbLwUTh4wS3eadOchQ8HIg57mGahx4RA3bcyg506NMa0yt/+abTmufQIR32yE8g5jBIMX6zak/cKBgHqHuCMd4h8vOv+XzmIg+P3XUpiMJOzKDtmapvqaMU5YzJxSaiVGO7oF5+BETd1cPZse9De0SyAGP6jv/yRXsmw3W9fcwoWRcx9GUoXcaRvEzt9fC1MDR4osgSxDxLo75RMfPllIlnRB6efFbr8YgsukBhJ4aeyyaqP+Azuv3ct44JWloVDN3pJGHLTe/utkckK5AcqhVadllvhwBInikYFDeEwlu+nOPygoDjNWPSBONpVvpert5hFuT5XSQZ6JEnDyMJIg8jShPXqB6FnRiwl1PTa/fZW99z4KA9cmfKhDH2KD2m7W3GTSDIABAzTL4aYL097R5jaWtiyTprUiCiKI6CPuIajD5nmD1y56Ocdqvg9/zRi2tFiWoRGGcwoiDwWmPuaGjcuUBhJ2fQ9NqRMNfIa3ZdoSHkCopQkHwwZUPnXGvP5KTdY3zpxbIQLQxADdGpBv5t9EeAwOFYs6yphB17P0jttUcGStL7BQMbxanwe6KctFbVN4g6tstpzKUHHBsJUdjJGbS8dnjrCE/5yke/77VH7hx1DBVioqa3ni9jR400VcU0QHgcHl5S0ZnRPd4euYM9zdKCJeVEIljeHwHillZQy+lsc+8hH4H7nGbpA88UOjLCMEmaGFve7AnnD65crXKvIe5j/0CWYyGBwk4+hYbX7uP2tlI0spVdsupZh7w4UFVMawscJv6VCXsLwFiWfi4+D8bEnv3yJSSINsQ7EsFyIKhJr60amksfeF6qCS2uZd2W7cY4QQXJSKRf3/purHFSzcDGM4qGLBrV3zQY0uFmJFHYyafARHTDH2NdcpjTC20QffbWQafjw1IKwn1pQqT4u5iA2A62ODS3wEEUkoatNQxdiMyDz602ApZWcCByGH9YQ4egx7UlxrWlGdvlYA7Rus8Q9weeW2O+O743XlGkAdfy/KtvnvVdYZxA8KsxEIKvHXbH58CYchV4s7ShsPNmtKOR1PJJiD0mnvDk+l8FG0KrUwKyM5HIUU/s2BeK3wtr7Zk7jy2+xR5VBqHH+0OrXAqWHG7vmR5cenF1j8xMIuEkUck7kLJk4dxEeQzfWPasPXIn7p5qoTEG4DEigakS+B20+gNgO9qd8/7MhPrjwHjTLF+MMYfsdiTnQURLix3tP3TEfBYyqneHL3ihaQ1KjO17F8w2Iu3C0lVrVYTNFfw2S8IxUOn7wzBIm0uA7m/TUDUyvO+4N9WAkYGIgdbzjq10Lo4Shd1DKOwykojQt//3j9W8Z0yyUyeMC7pKIgHRpCrxfOKgsFemlrADl4m9GkkFUNOgyIsvXYm9724lp413HeMVZ00lUYShff8zL9kzN2BIjR090vzm0TN/9MRJY8hoR+SSPuPlMBRPmhLNxBaIN0KCmLijlwnFZSjqxB3NLXAI0z4RGuJxQGDybpMs5eWN7uvM0m1+GsBzLufhVevskTsQbzzbW3buMf0m8MKxtqjDaHTdWURhJ03J1PHj7BFpNuBp3TZruj2Tg0k9SQRgwTWft0f1g2uXMRQH0lpndwXiW2pcw1DRXA7JGkluBoWdNCXYhlT0xEOKQ7MqHUB4Py5rXXPbXV5AGF2XLbIoU52WqMBPtGe9XoC3LilTS2EnTQm8Nh8mHlIcqPWvGR5fvjq+njy23SERq57AWnncdVUiizLVaYFhAoMLa/71hLTAF4WdNC0+TDykWDS3wCVdb7995hfMttB6AUbw/t6j9iw5vhjPSETumTqpbp5107hHuGWYwk6aFkw82LNPmhck0WmOgSTr7Rh36MuvlcCXJQgH35VwS18lYDwXfZ1IohsVer/33DTb+3uOEPyCay63Z+5Q2ElTg9Co5lorqT+0w+NYby9N2qoEBAb1xH313OHdYqlC2qcdRoxW3XRXULBm+3sfnrnnvoo7ttDBiNK4VxR20vRgAiuiWh4KjBA/QHhcc8JHNnncujQ+785QOH0zLOGl3/uXc9S+F65Tqzd+WiIDZartxojvghoH6E3vE9O7LwnuDI0OiRFVCoWdkBAUs8hzgsVn/ffZxUx25GzgWWpugcN6e5I2qPhcCA/GX9GeJMLA8GilXnolsAvhnpvm5Oq51zJQUMsAAl+0cR0ZHrf1fEH13lDYCbHkMcFGkyc+i/iF9hY4hOOTVl9DxAjjAolTeQMBxLhHCVaUTM0KrNPnsc6NZ+yOOV+MNVDwPe5eMLsQowoijqjBkoVfzsShoLATUkJWE2z0IN8bTmxZTp5EBgwuzXVvbLOKW2+PgLigDDQ8SYy/LL1b/Nv4jMhDz2spCteI68tCTGGg3DHnWmOgTBmfPGcC147vFD33Wd/3SNARNcjqs1gr3kNQV3p7wsmgGhCPItaNJZgiEm/+qz1zR6tGPqpU4bfAdhnXilWYbDDJzJh0dkEcrMGufO0te5aeBVdfbkK5caD3gJS8+g5ojIGu9jZRRAS/tea+ZwgYJvG0oETp5p17TYvg7Qp1yNF9ceolY8x4HIda5xkKWFLM84X5bu8H9p104PlCr4Yp48eohtVxzzfv2hvstT0fJJTe97yMego7IQnAZD9Q7MJ2ywpFGY0fSkFDiDHh5IKJHGHHqPMWIRpAYPbuP2jGIDq4Idsb/y0H4xDhaBh9Y0dhPHZ5PxZhtOwOnys8Y3jWKtWoxzWZaxuG9tAjczNOou8Wdcmr9v1A6Xcs7r4Hwf8HQA/IPtLOsdwAAAAASUVORK5CYII=";

export var MaxLength = 20;
// Method for check valid TIN No.
export function VerifyValidTIN(input,CustomRegex) {
    const regex = new RegExp(CustomRegex);
    return CustomRegex.test(input);
}
// export var CustomRegex = /^\d{10}$/;
export var CustomRegex = /^.{1,20}$/;

// Custom method to restrict special characters as per TIN Nunmber -
// Added by Ritesh for - BSE Fatca changes TIN number validation implementation
export const CountryList7 = ["AE", "TC", "SX", "MS", "MC", "MO", "KY", "VG", "BM", "BH", "BS", "LB", "VC", "WS","KN","AF", "DZ", "BJ", "BT", "BA", "BW", "BF", "KH", "TD", "CC", "KM", "CD", "CI", "CU", "DJ", "DO", "EG", "GQ", "FK", "FJ", "PF", "GA", "GU", "GW", "HT", "HM", "HN", "IR", "KI", "KP", "LA", "LS", "LY", "MK", "MW", "MQ", "MN", "MA", "MM", "NC", "NI", "NF", "PG", "PN", "RW", "ST", "SN", "SL", "SO", "GS", "LK", "SH", "SD", "SJ", "AX", "AS", "AO", "AQ", "BD", "BY", "BO", "BV", "IO", "BI", "CM", "CV", "CF", "CX", "CG", "SV", "ER", "ET", "GF", "TF", "GM", "GP", "GT", "GN", "GY", "IQ", "JO", "KG", "LR", "MG", "ML", "MR", "YT", "FM", "MZ", "NA", "NP", "AN", "NE", "NU", "MP", "PW", "PS", "PY", "PH", "PR", "PM", "SB", "SR", "SZ", "SY", "TW", "TJ", "TZ", "TH", "TL", "TG", "TK", "TO", "TN", "TM", "TV", "UG", "US", "UM", "UZ", "ZZ", "VN", "VI", "WF", "EH", "YE", "ZM", "ZW", "BL", "BQ", "ME", "MF", "RE", "RS", "SS", "VA", "VE", "XX","BN"];   // No Tax Identification No. Required

export const CountryList =  [
    "AI", "AG", "AR", "AM", "AW", "AZ", "BB", "BE", "BZ", "BG", "CK", "HR", "CW",
    "DM", "EC", "EE", "FO", "GE", "DE", "GR", "GL", "GD", "HU", "IL", "JM", "JP",
    "KZ", "KW", "LI", "LU", "MV", "MU", "NL", "NO", "PE", "PL", "QA", "RO", "LC",
    "SC", "SI", "ZA", "TR", "VU", "SK", "SA", "TT", "PT", "OM", "UA", "CR",
    "FR", "MD", "RU", "AU", "CA", "MT", "LT","GI"];                                                                        // Accepts Only Digits Ex - 0123456789
    export const CountryList2 = [
    "MX", "AL", "AD", "KE", "IE", "IN", "CY", "UY", "ES", "IT", "GG", "MY", "GB", 
    "SM", "HK", "GH", "CN", "SG"];                                                                                    // Accepts Alphanums Only Ex - N000000I
    export const CountryList3 = ["NG", "DK", "JE", "SE", "IS", "KR", "LV","PK","NR"];                                             // Accepts Digit number with Hypen Ex - 000000-000
    export const CountryList4 = ["FI", "PA", "CL"];                                                                          // Accepts ALPHANUMERIC & "-,+" 
    export const CountryList5 = ["IM"];                                                                                      // Accepts Alphanums & "-"
    export const CountryList6 = ["BR", "AT"];                                                                                // Accepts Number and "-" & "/" 
    export const CountryList8 = ["CZ"];                                                                                      // Accepts Number with "/" 
    export const CountryList9 = ["MH", "NZ"];                                                                                // Accepts Number with "-" 
    // const CountryList10 =["LT"];                                                                                   // No Tax Identification No. Required only for Legal Entity
    export const CountryList11 =["ID","CO"];                                                                                      // Accepts Numbers with (. and -)
    export const CountryList12 =["CH", "SZ"];

    export let AllCountrieswithTin = [...CountryList,...CountryList2,...CountryList3,...CountryList4,...CountryList5,...CountryList6,...CountryList8,...CountryList9,...CountryList11,...CountryList12]
export function createTinPattern(event: any, ContryCode:any): void {
    debugger
    var LegalEntity      = "LegalEntity";
    var Individual       = "Individual" ;
    var TinStructureType =  Individual ;
                                                                                    // Accepts Alphanums with (.)

        if(CountryList.includes(ContryCode)){               // Regex Pattern 1 - Accepts Only Digits
            debugger
            if(ContryCode === "CK"){
                MaxLength = 5;
                CustomRegex = /^\d{5}$/  // Only 5 Digits 
            }else if(ContryCode === "DM" || ContryCode === "GD" || ContryCode === "LC" || ContryCode === "VU"|| ContryCode === "BZ"){
                MaxLength = 6;
                CustomRegex = /^\d{6}$/  // Only 6 Digits 
            }else if(ContryCode === "MV" || ContryCode === "OM"){
                MaxLength = 7;
                CustomRegex = /^\d{7}$/  // Only 7 Digits 
            }else if (ContryCode === "AG"|| ContryCode === "AM" || ContryCode === "AW" || ContryCode === "MU" || ContryCode === "MT"){
                MaxLength = 8;
                CustomRegex = /^\d{8}$/  // Only 8 Digits
                if(TinStructureType == LegalEntity && ContryCode == "MT"){
                MaxLength = 9;
                CustomRegex = /^\d{9}$/  // Only 9 Digits for Legal Entity 
                } 
            }else if(ContryCode === "BG" || ContryCode === "CW" || ContryCode === "FO" || ContryCode === "GE" || ContryCode === "GR" || ContryCode === "IL" || ContryCode === "JM" ||  ContryCode === "NL" || ContryCode === "SC" || ContryCode === "PT" || ContryCode === "CR" || ContryCode === "CA" ){
                MaxLength = 9;
                CustomRegex = /^\d{9}$/  // Only 9 Digits 
                if(ContryCode == "CR" && TinStructureType == LegalEntity){
                MaxLength = 10;
                CustomRegex = /^\d{10}$/ // Only 10 Digits for LegalEntity
                }
                if(ContryCode == "PT"){
                    MaxLength = 9;
                    CustomRegex = /^[1-9]\d{8}$/
                }
            }else if(ContryCode === "AI" || ContryCode === "AZ" || ContryCode === "GL" || ContryCode === "HU" || ContryCode === "ZA" || ContryCode === "SK" || ContryCode === "TR" ||  ContryCode === "SA" || ContryCode === "QA" || ContryCode === "TT" || ContryCode === "UA" ){
                MaxLength = 10;
                CustomRegex = /^\d{10}$/ // Only 10 Digits 
                if(ContryCode == "GL" && TinStructureType == LegalEntity){
                MaxLength = 8;
                CustomRegex = /^\d{8}$/  // Only 8 Digits for Legal Entity
                }else if(ContryCode == "HU" && TinStructureType == LegalEntity){
                MaxLength = 11;
                CustomRegex = /^\d{11}$/ // Only 11 Digits for Legal Entity
                }else if( ContryCode == "UA" && TinStructureType == LegalEntity){
                MaxLength = 9;
                CustomRegex = /^\d{9}$/ // Only 9 Digits for Legal Entity
                }else if(ContryCode == "QA"){
                    MaxLength = 10;
                    CustomRegex = /^(?!0{10})\d{10}/
                }
            }else if(ContryCode === "HR" || ContryCode === "EE" || ContryCode === "DE" || ContryCode === "NO" || ContryCode === "PE" || ContryCode === "PL" || ContryCode === "AR"|| ContryCode === "BE" || ContryCode === "LT"){
                MaxLength = 11;
                CustomRegex = /^(?!0{11})\d{11}$/ // Only 11 Digits 
                if(ContryCode == "EE" && TinStructureType == LegalEntity){
                MaxLength = 8;
                CustomRegex = /^\d{8}$/  // Only 8 Digits for Legal Entities
                }else if (ContryCode == 'PL' && TinStructureType == LegalEntity) {
                MaxLength = 10;
                CustomRegex = /^\d{10}$/ // Only 10 Digits for Legal Entities
                }else if (ContryCode == 'NO' && TinStructureType == LegalEntity) {
                MaxLength = 9;
                CustomRegex = /^\d{9}$/ // Only 9 Digits for Legal Entities
                }else if(ContryCode == 'BE'){
                    MaxLength = 11;
                    CustomRegex = /^(?!0{11}$)\d{11}$/;
                }
            }else if(ContryCode === "JP" || ContryCode === "KZ" || ContryCode === "KW" || ContryCode === "LI" || ContryCode === "RU"){
                MaxLength = 12;
                CustomRegex = /^\d{12}$/ // Only 12 Digits 
                if(ContryCode == "KW" && TinStructureType == LegalEntity){
                MaxLength = 6;
                CustomRegex = /^\d{6}$/  // Only 6 Digits for Legal Entity 
                }else if(TinStructureType == LegalEntity && ContryCode == "JP"){
                MaxLength = 13;
                CustomRegex = /^\d{13}$/ // Only 13 Digits for Legal Entity      
                }else if(TinStructureType == LegalEntity && ContryCode == "RU"){
                MaxLength = 10;
                CustomRegex = /^\d{10}$/ // Only 10 Digits for Legal Entity      
                }else if(ContryCode === "RU"){
                    MaxLength = 12;
                    CustomRegex = /^(?!0{12})\d{12}/
                }
            }else if(ContryCode === "EC" || ContryCode === "LU" || ContryCode === "RO" || ContryCode === "FR" || ContryCode === "MD"){
                MaxLength = 13;
                CustomRegex = /^\d{13}$/ // Only 13 Digits 
                if(ContryCode == "LU" && TinStructureType == LegalEntity){
                MaxLength = 11;
                CustomRegex = /^\d{11}$/ // Only 11 Digits for Legal Entity
                }
                else if(ContryCode === "MD"){
                    MaxLength=13;
                    CustomRegex=/^(?!0{13})\d{13}/
                }
            }else if(ContryCode === "AU"){
                if(TinStructureType == Individual){
                MaxLength=9;
                CustomRegex = /^\d{8,9}$/ // 8 OR 9 Digits
                }else{
                MaxLength=11;
                CustomRegex = /^\d{11}$/  // 11 Digits for Legal Entities
                }
            }else if(ContryCode == "GI"){
                MaxLength=6;
                CustomRegex=/^(?!0{5,6})\d{5,6}$/;
            }else if(ContryCode === "BB"){
                MaxLength = 13;
                CustomRegex = /^1\d{12}/;
            }else if(ContryCode === "SI"){
                MaxLength = 8;
                CustomRegex = /^(?!0{8})\d{8}/
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList');
            // event.target.value = event.target.value.replace(/[^0-9]/g, '');
        }else if(CountryList2.includes(ContryCode)){        // Regex Pattern 2 - Accepts Alphanums Only
            if(ContryCode === "AD"){
                MaxLength=8;
                // CustomRegex = /^[A-Za-z]{1}\d{6}[A-Za-z]{1}$/    // (n)letters + (n) Digits + (n)letter
                CustomRegex = /^[A-Za-z]{1}-\d{6}-[A-Za-z]{1}$/    // (n)letters + (n) Digits + (n)letter
            }else if(ContryCode === "IE"){
                MaxLength=9;
                CustomRegex = /^\d{7}[A-Za-z]{1,2}$/             // 7 Digits + 1 OR 2 LETTERS
            }else if(ContryCode === "AL"){
                MaxLength=10;
                CustomRegex = /^[A-Za-z]{1}\d{8}[A-Za-z]{1}$/    // (n)letters + (n) Digits + (n)letter
            }else if(ContryCode === "KE"){
                MaxLength=11;
                CustomRegex = /^[A-Za-z]{1}\d{9}[A-Za-z]{1}$/    // (n)letters + (n) Digits + (n)letter
            }else if(ContryCode === "MX"){
                MaxLength=13;
                CustomRegex = /^[A-Za-z]{4}\d{6}[A-Za-z0-9]{3}$/ // (n)letters + (n) Digits + (n)Alphanums
                if(TinStructureType == LegalEntity){
                MaxLength=12;
                CustomRegex = /^[A-Za-z]{3}\d{6}[A-Za-z0-9]{3}$/ // (n)letters + (n) Digits + (n)Alphanums for Legal Entity
                }
            }else if(ContryCode === "IN"){
                MaxLength=10;
                CustomRegex = /^[A-Za-z0-9]{10}$/                // 10 CHARACTER COMBINING DIGIT NUMBER AND LETTER
            }else if(ContryCode === "CY" || ContryCode === "ES"){
                MaxLength=9;
                CustomRegex = /^\d{8}[A-Za-z]$/                  // 8 DIGITS + 1 LETTERS
            }else if(ContryCode === "UY"){
                MaxLength=10;
                CustomRegex = /^\d{9}[A-Za-z]/                 // 12 DIGITS + 1 LETTERS for Legal Entity
                if(TinStructureType == LegalEntity){
                MaxLength=10;
                CustomRegex = /^\d{9}[A-Za-z]$/                  // 9 DIGITS + 1 LETTERS for Legal Entity
                }
            }else if(ContryCode === "IT"){
                MaxLength=16;
                CustomRegex = /^[A-Za-z0-9]{16}$/                // 16 CHARACTER COMBINING DIGIT NUMBER AND LETTER
                if(TinStructureType == LegalEntity){
                MaxLength=11
                CustomRegex = /^[A-Za-z0-9]{11}$/                // 11 CHARACTER COMBINING DIGIT NUMBER AND LETTER for Legal Entity
                }
            }else if(ContryCode === "GG"){
                MaxLength=8;
                CustomRegex = /^(GY|gy)\d{6}$/                   // GY or gy + 6 Digits
                if(TinStructureType == LegalEntity){
                MaxLength=6;
                CustomRegex = /^\d{1,6}$/                        // Between 1 and 6 Digit number for Legal Entity
                }
            }else if(ContryCode === "MY"){
                MaxLength=13;
                CustomRegex = /^(IG|ig)\d{9,11}$/                // IG + (9-11) Digits
                if(TinStructureType == LegalEntity){
                MaxLength=15;
                CustomRegex = /^[A-Za-z]{1,2}\d{12,13}$/         // 1 OR 2 Letter + 12 OR 13 Numbers ...Last Digit must be 0 for Legal Entity
                }
            }else if(ContryCode === "GB"){
                MaxLength=10;
                CustomRegex = /^(\d{10}|[A-Za-z]{2}\d{6}[A-Za-z])$/ // 10 Digit number (UTR) OR 2 letters + 6 digit number + 1 letter (always A, B, C or D)(NINO)
            }else if(ContryCode === "SM"){
                if(TinStructureType == LegalEntity){
                    MaxLength=7;
                    CustomRegex = /^(SM|sm)\d{5}$/              // SM + 5 Digits
                }else if(ContryCode === "SM"){
                    MaxLength = 20;
                    CustomRegex = /^(?!0{2,20})\d{2,20}/
                }
                else{
                    MaxLength=10;
                    CustomRegex = /^\d{10}$/                    // 10 Digits
                }
            }else if(ContryCode === "HK"){
                if(TinStructureType === Individual){
                    MaxLength=9;
                    CustomRegex = /^[A-Z]{1,2}\d{6}[0-9A]{1}$/
                }
            }else if(ContryCode === "GH"){
                MaxLength=11
                CustomRegex = /^[pP]\d{10}$/               // 11 CHARACTER COMBINING DIGIT NUMBERS AND LETTERS
            }else if(ContryCode === "CN"){
                MaxLength=18
                CustomRegex = /^(?:(?!0{18})\d{18}|(?!0{17})\d{17}[xX])$/               // 18 CHARACTER COMBINING DIGIT NUMBERS AND LETTERS
            }else if(ContryCode === "SG"){
                MaxLength=9
                CustomRegex = /^[A-Za-z][0-9]{7}[A-Za-z]$/                // 9 CHARACTER COMBINING DIGIT NUMBERS AND LETTERS
                if(TinStructureType == LegalEntity){
                    MaxLength=10
                    CustomRegex = /^[A-Za-z0-9]{10}$/           // 10 CHARACTER COMBINING DIGIT NUMBERS AND LETTERS
                }
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList2');
            // event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
        }else if(CountryList3.includes(ContryCode)){        // Regex Pattern 3 - Accepts Digit number,Hypen
            if(ContryCode === "NG"){
                MaxLength=13;
                CustomRegex = /^\d{8}-\d{4}$/       // 8 Digit number,Hypen, 4 Digits
            }else if(ContryCode === "DK" || ContryCode === "SE"){
                MaxLength=10;
                CustomRegex = /^(?!0{10}$)\d{10}$/       // 6 Digit number,Hypen, 4 Digits
            }else if(ContryCode === "JE"){
                MaxLength=10;
                CustomRegex = /^(?!0{10})\d{10}$/ // 3 Digit number - 3 NUMBER - 4 NUMBER
                if(TinStructureType == LegalEntity){
                MaxLength=7;
                CustomRegex = /^[A-Za-z]{2}\d{1,5}$/ // 2 Letters + upto 5 digit number for Legal Entity
                }
            }else if(ContryCode === "IS"){
                MaxLength=10;
                CustomRegex = /^(?!0{10})\d{10}$/        // 6 Digits - 4 Digits
            }else if(ContryCode === "KR"){
                MaxLength=13;
                CustomRegex = /^(?!0{13})\d{13}$/        // 6 Digits - 7 Digits
                if(TinStructureType == LegalEntity){
                MaxLength=12;
                CustomRegex = /^\d{3}-\d{2}-\d{5}$/  // 3 Digit - 2 Digit - 5 Digit
                }
            }else if(ContryCode === "LV"){
                MaxLength=11;
                CustomRegex = /^\d{11}$/             // 11 Digits
            }else if(ContryCode === "PK"){
                MaxLength=13;
                CustomRegex = /^(?!0{13})\d{13}/  // 5 Digit - 7 Digit - 1 Digit
            }else if(ContryCode === "NR"){
                MaxLength=9;
                CustomRegex = /^(?!0{9})\d{9}/;
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList3');
            // event.target.value = event.target.value.replace(/[^0-9-]/g, ''); // Accepts Numbers & "-"
        }else if(CountryList4.includes(ContryCode)){        // Regex Pattern 4 - Accepts ALPHANUMERIC & "-,+" 
            if(ContryCode === "FI"){
                MaxLength=11;
                CustomRegex = /^\d{6}[+-A]\d{3}[A-Za-z0-9]$/ // 6 digits - 1 character which can be + (plus), - (minus) or the letter A - 3 digits - 1 alphanumeric character
                if(TinStructureType == LegalEntity){
                MaxLength=8;
                CustomRegex = /^\d{8}$/                      // 8 Digits for Legal Entities
                }
            }else if( ContryCode === "PA"){
                if(TinStructureType === Individual){
                MaxLength=15;
                CustomRegex = /^(?!0{13})\d{13}[dD][vV]/
                }else{
                MaxLength=15;
                CustomRegex = /^\d{4}-\d{3}-\d{4}(DV|dv)$/
                }
            }else if(ContryCode === "CL"){
                MaxLength=9;
                CustomRegex = /^(?:(?!0{9})\d{9}|(?!0{8})\d{8}[kK])$/  // 8 OR 9 Digits - K OR 0
            }
            // else if(ContryCode === "BN"){
            //     MaxLength = 11;
            //     CustomRegex = /^(?:[0-9]{2}-[0-9]{6}|[0-9]{8}|P[0-9]{8}|RC[0-9]{8}|RFC[0-9]{8})$/
            // }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList4');
            // event.target.value = event.target.value.replace(/[^A-Za-z0-9\-+.]/g, ''); // ACCEPTS ALPHANUMERIC & "-,+"  
        }else if(CountryList5.includes(ContryCode)){        // Regex Pattern 5 - Accepts Alphanums & "-"
            if(ContryCode === "IM"){
                MaxLength=9;
                CustomRegex = /^[A-Za-z]\d{8}$/                                // 1 LETTER 6 Digit number,Hypen, 2 NUMBER
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList5');
            // event.target.value = event.target.value.replace(/[^A-Za-z0-9\-]/g, '');  // ACCEPTS ALPHANUMERIC & "-"  
        }else if(CountryList6.includes(ContryCode)){        // Regex Pattern 6 - Accepts Number and "-" & "/"
            if(ContryCode === "BR"){
                if(TinStructureType == LegalEntity){
                MaxLength=13;
                CustomRegex = /^(?!0{2}\.0{3}\/0{4}-0{2}$)\d{2}\.\d{3}\/\d{4}-\d{2}$/ // 5 Digit + slash + 4 Digit + hypen + 2 Digit
                }else{
                MaxLength=11;
                CustomRegex = /^(?!0{11}$)\d{11}$/ // 8 Digit + slash + 4 Digit + hypen + 2 Digit
                }
            }else if(ContryCode === "AT"){
                MaxLength=9;
                CustomRegex =/^(?!^[0\-\/]+$)\d{2}-?\d{3}\/?\d{4}$/ // 9 Digit with / and - (but symbols not mandatory)
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList6');
            // event.target.value = event.target.value.replace(/[^0-9\-\/]/g, '');      // Accepts ALPHANUMERIC & "-,/"  
        }
        else if(CountryList8.includes(ContryCode)){        // Regex Pattern 7 - Accepts Number & "/"
            if(ContryCode === "CZ"){
                if(TinStructureType == LegalEntity){
                MaxLength=11;
                CustomRegex = /^\d{6}\/\d{4}$/        // 6 Digit + slash + 4 Digit for Legal Entity
                }else{
                MaxLength=9;
                CustomRegex = /^(?!0{9}$)\d{9}$/       // 6 Digit + slash + 3 Digit
                }
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList8');
            // event.target.value = event.target.value.replace(/[^0-9]/g, '');  // Accepts Number with /  
        }
        else if(CountryList9.includes(ContryCode)){        // Regex Pattern 8 - Accepts Number & "-"
            if(ContryCode === "MH"){
                MaxLength=7;
                CustomRegex = /^(?!0{7})\d{7}/                                 // 5 Digit + hyphen + 2 Digit
                if(TinStructureType == LegalEntity){
                MaxLength=9;
                CustomRegex = /^\d{2}-\d{6}$/                                 // 2 Digit + hyphen + 6 Digit for Legal Entity
                }
            }else if(ContryCode === "NZ"){
                MaxLength=9;
                // CustomRegex = /^(?!0{8,9})\d{8,9}/                         //  ( 2 OR 3 ) Digit - 3 Digit - 3 Digit
                CustomRegex = /^\d{2,3}-\d{3}-\d{3}$/                         //  ( 2 OR 3 ) Digit - 3 Digit - 3 Digit
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList9');
            //event.target.value = event.target.value.replace(/[^0-9-]/g, '');  // Accepts Numbers with hyphen  
        }else if(CountryList11.includes(ContryCode)){       // Regex Pattern 9 - Accepts Numbers, Dot & hypen
            if(ContryCode === "ID"){
                MaxLength=15;
                CustomRegex = /^(?!0{15})\d{15}$/         // 2 digit . 3 digit . 3 digit. 1 digit - 3digit . 3 digit
            }
            else if(ContryCode == "CO"){
                MaxLength=13;
                CustomRegex = /^(?!0{1,13})\d{1,13}$/;
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList11');
            // event.target.value = event.target.value.replace(/[^0-9.-]/g, '');  // Accepts Numbers with Dot and -  
        }else if(CountryList12.includes(ContryCode)){       // Regex Pattern 10- Accepts Alphanums, Dot & hypen
            if(ContryCode === "CH" || ContryCode === "SZ"){
                MaxLength=13;
                CustomRegex = /(?!0{13})\d{13}/;                      // 3 digit . 4 digit . 4 digit. 2 digit
                if(TinStructureType === LegalEntity){
                    MaxLength=15;
                    CustomRegex = /^(CHE|che)-\d{3}.\d{3}.\d{3}$/                             
                }
            }
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList12');
            // event.target.value = event.target.value.replace(/[^A-Za-z0-9.-]/g, '');  // Accepts Alphanums with Dot and -  
        }else if(CountryList7.includes(ContryCode)){
            MaxLength = 20;
            CustomRegex = /^[A-Za-z0-9]{1,20}$/;
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList7');
            // event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
        }
        else{
            MaxLength = 20;
            CustomRegex = /^[A-Za-z0-9]{1,20}$/;
            console.log(VerifyValidTIN(event.target.value,CustomRegex),'CountryList7');
            console.log("No Country Found..")
        }
}

// Use below methods in your components to verify valid Tin Number

// ********************* HTML ********************************************************************************************
//  (input)="ContryWiseTinPattern($event)" Add input event on your Input tag
//  [attr.maxlength]="MaxLength" - Add dynamic max length attribute on your Input tag

// <input type="text" id="TaxIdentificationNo" formControlName="TaxIdentificationNo" 
// [attr.maxlength]="MaxLength" (input)="ContryWiseTinPattern($event)"  class="form-control CommonTextBox TbxMarginBtm" placeholder="&nbsp;" 
//   [ngClass]="{ 'is-invalid': FATCADetailsFormSubmitted && c.TaxIdentificationNo.errors }" />


// validation modal 
// ** Call ClearTinNo method on okay button
// <button type="button" data-bs-dismiss="modal" class="CursorPointer" (click)="ClearTinNo()">Okay</button>



// ******************** .ts *************************************************************************************************
// import { MaxLength, CustomRegex, VerifyValidTIN, createTinPattern } from 'src/app/validation';

//  set properties in your component.ts file
//   MaxLength:number;
//   CustomRegex:any;


// Add validation on your input 
// TaxIdentificationNo: ['',[Validators.maxLength(this.MaxLength)]], // Added validation as per Birth Country - BSE Fatca changes TIN number validation implementation

// Method added by Ritesh for - BSE Fatca changes TIN number validation implementation
//    ContryWiseTinPattern(event: any): void {
//     this.MaxLength = MaxLength;
//     this.CustomRegex = CustomRegex;
//     var ContryCode = this.FATCADetailsForm.controls["BirthCountry"].value
//     console.log(this.FATCADetailsForm.controls["BirthCountry"].value, 'BirthCountry Code');
//     createTinPattern(event, ContryCode)
//     const IsValidTin = VerifyValidTIN(event.target.value, CustomRegex);
//     if (!IsValidTin && event.target.value.length == MaxLength) {
//       this.CallAlertModal("The format of the entered value is incorrect.")
//       const inputElement = event.target as HTMLInputElement;
//       inputElement.blur();
//     }
//   }
//   ClearTinNo(){
//     this.FATCADetailsForm.controls["TaxIdentificationNo"].setValue('')
//   }